module.exports = __webpack_public_path__ + "img/2_122.2f31f212.png";